export default __webpack_public_path__ + "static/media/yaksha.e0da52f9.png";